module.exports = __webpack_public_path__ + "static/media/integrationIFrame.102fb8fa.md";